import React from 'react';
export const PageOf = ({ page, pages }) => (React.createElement("div", null,
    "Page ",
    page,
    " of ",
    pages));
//# sourceMappingURL=PageOf.js.map